import { useMemo } from 'react';
import { useOLMap } from '@tmapy/mapcore';
import { useDispatch, useSelector } from '@tmapy/redux';
import { getAbsoluteUrl, QUERY_STATE, useFetch } from '@tmapy/utils';
import { actionUpdateLegendState } from '../actions';
const getWMSLegendUrl = (layer, layerConfig) => {
    if (layer) {
        const url = getAbsoluteUrl(layer?.getSource()?.getUrl());
        const sourceOptions = layerConfig?.sourceOptions;
        const layers = sourceOptions?.params?.LAYERS || url.searchParams.get('layers') || '';
        const path = `${url.origin}${url.pathname}`;
        // tmapy gservice = json, WMS standard = image
        const format = path.includes('/gservice') ? 'json' : 'image/png';
        return {
            format,
            url: `${path}?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=${layers}&format=${format}&STYLE=default`,
        };
    }
    return { format: '', url: '' };
};
export const useWMSLegend = (layerId) => {
    const dispatch = useDispatch();
    const legends = useSelector((state) => state.legend);
    const cachedLegend = legends.find((legend) => legend.layerId === layerId)?.items;
    const layerConfig = useSelector((state) => state.mapCore.layers).find((layer) => layer.id === layerId);
    const map = useOLMap();
    const layers = map.getLayers();
    const layer = layers
        .getArray()
        .find((layer) => layer.getProperties().id?.split('&').includes(layerId));
    const { format, url } = getWMSLegendUrl(layer, layerConfig);
    const isImageLegend = format !== 'json';
    const { queryState, data } = useFetch(cachedLegend?.length || isImageLegend ? null : url);
    const legendData = useMemo(() => {
        const legendItems = [];
        if (queryState === QUERY_STATE.SUCCESS) {
            data.layers.map((layer) => layer.classes.map((legend) => legendItems.push({
                imgSrc: legend.iconData
                    ? `data:${legend.contentType};base64,${legend.iconData}`
                    : legend.iconUrl,
                label: legend.title,
            })));
            dispatch(actionUpdateLegendState({ layerId, legendItems }));
        }
        return legendItems;
    }, [queryState, dispatch, layerId, data]);
    const imageLegendData = useMemo(() => {
        const legendItems = [];
        if (isImageLegend && !cachedLegend?.length) {
            legendItems.push({ imgUrl: url });
            dispatch(actionUpdateLegendState({ layerId, legendItems }));
        }
        return legendItems;
    }, [dispatch, isImageLegend, layerId, url, cachedLegend]);
    return {
        format,
        items: cachedLegend?.length ? cachedLegend : isImageLegend ? imageLegendData : legendData,
    };
};
//# sourceMappingURL=useWMSLegend.js.map